import React from 'react'
import FlexLayout from './FlexLayout'
import DetailsBox from './DetailBox'

const CommonLayout = ({prevData,newData,fieldsData,showPopupHanldel}) => {
  
  return <>
    <div style={{ width: "85%" }}>
      <FlexLayout
        col1={
          <>
            <DetailsBox
              heading="Previous Contents (Read Only)"
              btnText="Preview in Pop-up Table"
              prevData={prevData}
              newData={prevData}
              fieldsData={fieldsData}
              onShowPopup={showPopupHanldel}
            />
          </>
        }
        col2={
          <>
            <DetailsBox
              heading="Changed To (Read Only)"
              btnText="Preview in Pop-up Table"
              prevData={prevData}
              newData={newData}
              fieldsData={fieldsData}
              onShowPopup={showPopupHanldel}
            />
          </>
        }
      />
    </div>
  </>
}

export default CommonLayout